export { default as CornerstoneWidgetBlock } from './cornerstone-widget-block-container';


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/index.js